import { render, staticRenderFns } from "./DiaRegular.vue?vue&type=template&id=68c11900&"
import script from "./DiaRegular.vue?vue&type=script&lang=js&"
export * from "./DiaRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports